module.exports = __webpack_public_path__ + "static/media/วอก.e596ff7e.jpg";